"use strict";

SITE.pageScript = SITE.pageScript || {
  init: {}
};
SITE.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    initInview();
    initModal();
    initParallax();
    initHeader();
    initProduct();
    productColorSelect();
    initFv();
    enTextParallax();
  }
  function enTextParallax() {
    var section = document.querySelector('.about');
    var items = document.querySelectorAll('.js-parallax');
    if (!section || !items.length) return;
    var maxMove = 80;
    var maxMoveSp = 100;
    var baseProgress = null;
    function update() {
      var rect = section.getBoundingClientRect();
      var progress = -rect.top;
      var winH = window.innerHeight;
      if (baseProgress === null && rect.top < winH && rect.bottom > 0) {
        baseProgress = progress;
      }
      if (baseProgress === null) return;
      items.forEach(function (item) {
        var speed = parseFloat(item.dataset.speed) || 0.08;
        var offset = (progress - baseProgress) * speed;
        offset = Math.max(Math.min(offset, maxMove), -maxMove);
        item.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
        var winW = window.innerWidth;
        if (winW < 1024) {
          offset = Math.max(Math.min(offset, maxMoveSp), -maxMoveSp);
          item.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
        } else {
          item.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
        }
      });
    }
    window.addEventListener('scroll', update, {
      passive: true
    });
    update();
  }
  function initProductIntroLeave() {
    var $section = $('.productIntro');
    var $slowest = $section.find('.productIntro_signature.js-inview');
    if (!$section.length || !$slowest.length) return;
    var $win = $(window);
    var leaveTimer = null;
    var slowestInviewAt = null;
    var contentHadTimeToShow = false;
    function update() {
      var rect = $section[0].getBoundingClientRect();
      var winH = $win.height();
      var now = Date.now();
      if ($slowest.hasClass('is-inview')) {
        if (slowestInviewAt === null) slowestInviewAt = now;
        if (now - slowestInviewAt >= 1000) contentHadTimeToShow = true;
      } else {
        slowestInviewAt = null;
      }
      if (rect.bottom < 0 || rect.top > winH) {
        contentHadTimeToShow = false;
      }
      if (rect.top < -80) {
        if (!$section.hasClass('is-out') && !leaveTimer && contentHadTimeToShow) {
          leaveTimer = setTimeout(function () {
            $section.addClass('is-out');
            leaveTimer = null;
          }, 400);
        }
      } else {
        if (leaveTimer) {
          clearTimeout(leaveTimer);
          leaveTimer = null;
        }
        if (rect.top < winH * 0.5) {
          $section.removeClass('is-out');
        }
      }
    }
    update();
    $win.on('scroll.productIntroLeave resize.productIntroLeave', update);
  }
  function initFv() {
    var $items = $('.fv').children();
    if (!$items.length) return;
    var delayStep = 2 / $items.length;
    $items.each(function (i) {
      var $el = $(this);
      setTimeout(function () {
        $el.addClass('is-show');
      }, i * delayStep * 1000);
    });
  }
  function setupPathAnimation() {
    // clip-pathアニメーション用にmask内のパスを処理
    var maskPaths = document.querySelectorAll('.fv_textMask_path_pc, .fv_textMask_path_sp');

    // mask内のパスにアニメーションを設定（mask要素全体を再作成する方法）
    maskPaths.forEach(function (path, index) {
      var className = path.className.baseVal || path.className;
      var parentSVG = path.closest('svg');
      var svgExists = parentSVG !== null;
      if (!svgExists) {
        return;
      }
      var svg = path.closest('svg');
      var textWrap = svg ? svg.querySelector('.fv_mainVisual_textWrap') : null;
      var mask = path.closest('mask');
      var maskId = mask ? mask.getAttribute('id') : null;
      var defs = svg.querySelector('defs');
      if (!textWrap || !mask || !maskId || !defs) {
        return;
      }

      // 元のパスの属性を保存
      var pathD = path.getAttribute('d');
      var strokeWidth = path.getAttribute('stroke-width') || '60';
      var strokeColor = path.getAttribute('stroke') || '#fff';

      // パスの長さを取得（非表示でも取得できるように）
      var length = 0;
      try {
        // SVGが非表示の場合でも、一時的に表示して長さを取得
        var originalDisplay = svg.style.display;
        var originalVisibility = svg.style.visibility;
        var originalPosition = svg.style.position;
        var originalOpacity = svg.style.opacity;

        // 一時的に表示（画面外に配置）
        svg.style.display = 'block';
        svg.style.visibility = 'hidden';
        svg.style.position = 'absolute';
        svg.style.opacity = '0';
        svg.style.left = '-9999px';
        svg.style.top = '-9999px';

        // 強制的にリフロー
        svg.offsetHeight;

        // パスの長さを取得
        length = path.getTotalLength();

        // 元に戻す
        svg.style.display = originalDisplay;
        svg.style.visibility = originalVisibility;
        svg.style.position = originalPosition;
        svg.style.opacity = originalOpacity;
        svg.style.left = '';
        svg.style.top = '';
      } catch (e) {
        // 取得できない場合はパスデータから推定（フォールバック）
        length = pathD.length * 2; // 簡易的な推定値
      }
      if (length <= 0) {
        return;
      }

      // CSSアニメーションとtransitionを完全に無効化
      path.style.animation = 'none';
      path.style.transition = 'none';
      path.style.strokeDasharray = '';
      path.style.strokeDashoffset = '';

      // 初期状態を設定
      path.setAttribute('stroke-dasharray', length);
      path.setAttribute('stroke-dashoffset', length);

      // JavaScriptで直接アニメーション（requestAnimationFrame使用）
      var startTime = null;
      var duration = 2200; // 2.2秒
      var animationStarted = false;

      // cubic-bezier(0.5, 1, 0.68, 1) の簡易イージング関数
      var easing = function easing(t) {
        return 1 - Math.pow(1 - t, 3);
      };

      // mask要素全体を再作成する関数（実機で確実に反映されるように）
      var recreateMask = function recreateMask(progress) {
        var currentLength = length * progress;
        var dashArray = length;
        var dashOffset = length - currentLength;

        // 新しいパス要素を作成
        var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        newPath.setAttribute('d', pathD);
        newPath.setAttribute('stroke', strokeColor);
        newPath.setAttribute('stroke-width', strokeWidth);
        newPath.setAttribute('fill', 'none');
        newPath.setAttribute('stroke-dasharray', dashArray);
        newPath.setAttribute('stroke-dashoffset', dashOffset);

        // 既存のパスを削除して新しいパスに置き換え
        while (mask.firstChild) {
          mask.removeChild(mask.firstChild);
        }
        mask.appendChild(newPath);

        // maskの参照を一度外して再設定（強制的に再描画）
        textWrap.removeAttribute('mask');
        textWrap.offsetHeight; // リフロー
        textWrap.setAttribute('mask', 'url(#' + maskId + ')');
      };
      var _animate = function animate(currentTime) {
        if (!startTime) {
          startTime = currentTime;
        }
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easing(progress);

        // mask要素全体を再作成
        recreateMask(easedProgress);
        if (progress < 1) {
          requestAnimationFrame(_animate);
        } else {
          // 最終状態：完全に表示
          recreateMask(1);
        }
      };

      // SVGが表示されているかチェックする関数
      var isSVGVisible = function isSVGVisible() {
        var rect = svg.getBoundingClientRect();
        var style = window.getComputedStyle(svg);
        return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      };

      // アニメーション開始関数
      var startAnimation = function startAnimation() {
        if (animationStarted) return;
        animationStarted = true;

        // SVGが表示されているか確認
        if (!isSVGVisible()) {
          // 表示されるまで待つ（SP版の場合）
          var checkInterval = setInterval(function () {
            if (isSVGVisible() || animationStarted) {
              clearInterval(checkInterval);
              if (!animationStarted) {
                setTimeout(function () {
                  requestAnimationFrame(_animate);
                }, 200);
              }
            }
          }, 100);

          // 最大5秒待つ
          setTimeout(function () {
            clearInterval(checkInterval);
            if (!animationStarted) {
              requestAnimationFrame(_animate);
            }
          }, 5000);
        } else {
          // すぐにアニメーション開始
          setTimeout(function () {
            requestAnimationFrame(_animate);
          }, 200);
        }
      };

      // IntersectionObserverを使ってSVGが表示されたときにアニメーション開始
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
              startAnimation();
              observer.disconnect();
            }
          });
        }, {
          threshold: 0.1
        });
        observer.observe(svg);

        // フォールバック：3秒後に強制的に開始
        setTimeout(function () {
          if (!animationStarted) {
            startAnimation();
          }
        }, 3000);
      } else {
        // IntersectionObserverが使えない場合は通常通り開始
        startAnimation();
      }
    });
  }
  window.addEventListener('load', setupPathAnimation);
  function initHeader() {
    var $header = $('.js-header');
    var $fv = $('.fv');
    var $footer = $('.footer');
    var $win = $(window);
    if (!$header.length || !$fv.length || !$footer.length) return;
    var footerMargin = 80;
    function updateHeader() {
      var st = $win.scrollTop();
      var winH = $win.height();
      var fvBottom = $fv.offset().top + $fv.outerHeight();
      var footerTop = $footer.offset().top;
      var pastFv = st > fvBottom;
      var nearFooter = st + winH > footerTop - footerMargin;
      $header.toggleClass('is-visible', pastFv && !nearFooter);
    }
    updateHeader();
    $win.on('scroll.header resize.header', updateHeader);
  }
  function initModal() {
    var $modal = $('.modal_overlay');
    var $tabs = $('.modal_contentTab_title');
    var $contents = $('.modal_contentList_detail');
    var $items = $('.product_detailItem');
    var $win = $(window);
    var lockScrollTop = 0;
    function modalScrollLock() {
      lockScrollTop = $win.scrollTop();
      $('body').css('top', -lockScrollTop + 'px');
    }
    function modalScrollUnlock() {
      $('body').css('top', '');
      $win.scrollTop(lockScrollTop);
    }
    function closeModal() {
      $modal.removeClass('is-open');
      $('body').removeClass('is-modalOpen');
      modalScrollUnlock();
    }
    function switchTab(i) {
      $tabs.removeClass('is-active').eq(i).addClass('is-active');
      $contents.removeClass('is-active').eq(i).addClass('is-active');
    }
    if (!$modal.length || !$items.length) return;
    $items.on('click', function () {
      var i = $items.index(this);
      switchTab(i);
      modalScrollLock();
      $modal.addClass('is-open');
      $('body').addClass('is-modalOpen');
    });
    $tabs.on('click', function () {
      switchTab($tabs.index(this));
    });
    $('.modal_close').on('click', closeModal);
    $modal.on('click', function (e) {
      if (e.target === this) closeModal();
    });
  }
  function initParallax() {
    var $parallax = $('.parallax');
    var $parallaxBg = $('.parallax-bg');
    var $feature = $('.feature');
    var $win = $(window);
    if (!$parallax.length || !$parallaxBg.length || !$feature.length) return;
    var speed = 0.03;
    function updateParallax() {
      var st = $win.scrollTop();
      var featureTop = $feature.offset().top;
      var startFrom = featureTop + 200;
      var offset = Math.max(0, st - startFrom);
      var maxTranslate = $win.height() * 0.2;
      var translateY = Math.min(offset * speed, maxTranslate);
      $parallax.toggleClass('is-visible', st >= startFrom);
      $parallaxBg[0].style.transform = 'translateY(' + translateY + 'px)';
    }
    updateParallax();
    $win.on('scroll.parallax resize.parallax', updateParallax);
  }
  function initInview() {
    var $targets = $('.js-inview');
    if (!$targets.length) return;
    var $win = $(window);
    var winH = $win.height();
    function onScroll() {
      var scrollBottom = $win.scrollTop() + winH * 0.8;
      $targets.each(function () {
        var $el = $(this);
        if (!$el.hasClass('is-inview') && $el.offset().top < scrollBottom) $el.addClass('is-inview');
      });
    }
    onScroll();
    $win.on('scroll.inview resize.inview', function () {
      winH = $win.height();
      onScroll();
    });
  }
  function initProduct() {
    var $cta = $('.product_cta');
    var $ctaText = $cta.find('.product_ctaButton .product_ctaText');
    $cta.on('mouseleave', function () {
      requestAnimationFrame(function () {
        $ctaText.addClass('is-leaving');
        setTimeout(function () {
          $ctaText.removeClass('is-leaving');
        }, 850);
      });
    });
    initProductImageSlider();
  }
  function initProductImageSlider() {
    var $lists = $('.product_imageArea').find('.product_imageArea_list');
    var interval = 2000;
    $lists.each(function () {
      var $area = $(this);
      var $images = $area.find('.product_image');
      if ($images.length < 2) return;
      var timer = null;
      function goNext() {
        var $active = $images.filter('.is-active').first();
        var currentIndex = $images.index($active);
        if (currentIndex < 0) currentIndex = 0;
        var nextIndex = (currentIndex + 1) % $images.length;
        $images.removeClass('is-active').eq(nextIndex).addClass('is-active');
      }
      function startTimer() {
        if (timer) return;
        timer = setInterval(goNext, interval);
      }
      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }
      $area.on('mouseenter', stopTimer).on('mouseleave', startTimer);
      startTimer();
    });
  }
  function productColorSelect() {
    var $product = $('.product');
    if (!$product.length) return;
    var $labels = $product.find('.product_colorLabel');
    var $labelArea = $labels.parent();
    var $dot = $labelArea.find('.product_colorLabel_dot');
    var $options = $product.find('.product_colorOption');
    var $sizeOptions = $product.find('.product_sizeOption');
    var $ctas = $product.find('.js-product-cta');
    var state = {
      colorIndex: 0,
      size: $sizeOptions.filter('.is-active').first().data('size') || $sizeOptions.first().data('size') || '1'
    };
    function getColorName(index) {
      return index === 0 ? 'black' : 'white';
    }
    function updateDotPosition() {
      if (!$dot.length) return;
      var $selected = $labels.eq(state.colorIndex);
      $labelArea.css('--product-colorLabel-dot-top', $selected.position().top + $selected.outerHeight() / 2 + 'px');
    }
    function updateView() {
      var colorIndex = state.colorIndex;
      var colorName = getColorName(colorIndex);
      $product.find('.product_imageArea_list').removeClass('is-visible').filter('[data-color="' + colorName + '"]').addClass('is-visible');
      $product.find('.product_image').removeClass('is-active');
      $product.find('.product_imageArea_list[data-color="' + colorName + '"] .product_image').first().addClass('is-active');
      $labels.removeClass('is-selected').eq(colorIndex).addClass('is-selected');
      updateDotPosition();
      $options.removeClass('is-active').eq(colorIndex).addClass('is-active');
      $sizeOptions.each(function () {
        var $btn = $(this);
        $btn.toggleClass('is-active', $btn.data('size') === state.size);
      });
      $ctas.removeClass('is-active').filter(function () {
        var $this = $(this);
        return $this.data('color') === colorName && $this.data('size') === state.size;
      }).addClass('is-active');
    }
    $product.on('click', '.product_colorLabel, .product_colorOption, .product_sizeOption', function () {
      var $t = $(this);
      if ($t.hasClass('product_colorLabel')) state.colorIndex = $labels.index(this);else if ($t.hasClass('product_colorOption')) state.colorIndex = $options.index(this);else if ($t.hasClass('product_sizeOption')) state.size = $t.data('size');
      updateView();
    });
    updateView();
    $(window).on('resize.productColorSelect', updateDotPosition);
  }
  return {
    init: init
  };
}();
SITE.common.init(SITE.pageScript.init);